import React from 'react';
import AppVars from '../../AppVars.js'
import ActivateSuccessView from '../Views/TO/Activate/ActivateSuccessView';

let appVars = AppVars.getInstance();


class ActivateSuccess extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
            redirectURI: this.props.redirectURI
        }
    }


    render() {
        return(
            <ActivateSuccessView
            login = {this.login}
            redirectURI = {this.state.redirectURI}
            />
        )
    }

    login() {
        //let dest = this.parseRedirectFromURL() == null ? "/" : this.parseRedirectFromURL();
        window.location.href = this.props.redirectURI;
    }


    parseRedirectFromURL() {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let redirect_uri = params.get('redirect_uri');
        return redirect_uri
    }

}

export default ActivateSuccess